import { useContext } from "react";
import PopUpContext from "../../../store/providers/PopUpContext";
import { motion, AnimatePresence } from "framer-motion";
import reactDom from "react-dom";
import Foresight_Icon_White from "../../../assets/img/Foresight_Icon_White.svg";
import CloseSvg from "../CloseSvg/CloseSvg";
import "./PopUp.scss";
import popUpVariants from "../../../Services/variants/popUpVariants";

const PopUp = ({ message }) => {
	const popUpCtx = useContext(PopUpContext);

	const hidePopUpHandler = () => {
		popUpCtx.hidePopUp()
	}

	return reactDom.createPortal(
		<AnimatePresence>
			{popUpCtx.popUp && (
				<motion.div className="popUp--motion-container" variants={popUpVariants} initial="hidden" animate="visible" exit="exit">
					<div className="popUp--container">
						<div className="flex center-cross-axis end-main-axis popUp--svg-container">
							<CloseSvg pointer clickHandler={hidePopUpHandler} />
						</div>
						<div className="flex center-cross-axis space-around">
							<img src={Foresight_Icon_White} alt="Foresight Logo" />
							<h1 className="c-white">{popUpCtx.popUp.message}</h1>
						</div>
					</div>
				</motion.div>
			)}
		</AnimatePresence>,
		document.getElementById("portal")
	);
};

export default PopUp;
